import React from 'react';
import { MusicIcon } from 'lucide-react';
type LyricsDividerProps = {
  lyrics: string;
  attribution: string;
};
export function LyricsDivider({
  lyrics,
  attribution
}: LyricsDividerProps) {
  return <div className="w-full bg-gradient-to-r from-indigo-600 to-indigo-800 py-12 px-4" data-id="element-244">
      <div className="container mx-auto max-w-4xl flex flex-col items-center justify-center text-center" data-id="element-245">
        <MusicIcon className="text-white/80 mb-4" size={32} data-id="element-246" />
        <p className="text-white text-xl md:text-2xl font-light mb-4 leading-relaxed" data-id="element-247">
          <i data-id="element-248">"{lyrics}"</i>
        </p>
        <p className="text-white/80 text-sm md:text-base font-medium" data-id="element-249">
          From {attribution}
        </p>
      </div>
    </div>;
}